const Dot = ({ color }) => (
  <span className="inline-block w-2 h-2 rounded-full flex-shrink-0" style={{ background: color }} />
);

const OrderTypeCard = ({ label, accent, primary, pending, orders, pct }) => (
  <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-3.5" style={{ borderLeftColor: accent, borderLeftWidth: 3 }}>
    <div className="flex items-center gap-1.5 mb-2">
      <Dot color={accent} />
      <span className="text-xs font-medium text-gray-500">{label}</span>
    </div>
    <p className="text-base font-bold text-gray-800 leading-tight">{primary}</p>
    {pending ? (
      <p className="text-xs text-gray-400 mt-1">{pending} pending</p>
    ) : null}
    <div className="mt-2 pt-2 border-t border-gray-50 flex items-center justify-between">
      <span className="text-xs text-gray-400">{orders} orders</span>
      <span className="text-xs font-semibold rounded-full px-2 py-0.5" style={{ background: `${accent}18`, color: accent }}>
        {pct}%
      </span>
    </div>
  </div>
);

const OrderTypeCards = ({ returnsCancellations, orderType }) => {
  const totalRaw =
    (orderType.b2c?.amount_raw || 0) +
    (orderType.b2b?.amount_raw || 0) +
    (orderType.third_party?.amount_raw || 0);

  const pct = (raw) => (totalRaw > 0 ? ((raw / totalRaw) * 100).toFixed(1) : "0.0");

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {/* Returns & Cancellations */}
      <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-3.5" style={{ borderLeftColor: "#E24B4A", borderLeftWidth: 3 }}>
        <div className="flex items-center gap-1.5 mb-2">
          <Dot color="#E24B4A" />
          <span className="text-xs font-medium text-gray-500">Returns &amp; Cancellations</span>
        </div>
        <p className="text-base font-bold" style={{ color: "#E24B4A" }}>{returnsCancellations.count} orders</p>
        <div className="mt-2 pt-2 border-t border-gray-50 flex items-center justify-between">
          <span className="text-xs" style={{ color: "#E24B4A" }}>{returnsCancellations.amount}</span>
          <span className="text-xs text-gray-400">value lost</span>
        </div>
      </div>

      <OrderTypeCard label="B2C" accent="#378ADD" primary={orderType.b2c?.amount} pending={orderType.b2c?.amount_pending} orders={orderType.b2c?.orders} pct={pct(orderType.b2c?.amount_raw)} />
      <OrderTypeCard label="B2B" accent="#1D9E75" primary={orderType.b2b?.amount} pending={orderType.b2b?.amount_pending} orders={orderType.b2b?.orders} pct={pct(orderType.b2b?.amount_raw)} />
      <OrderTypeCard label="Third Party" accent="#7F77DD" primary={orderType.third_party?.amount} pending={orderType.third_party?.amount_pending} orders={orderType.third_party?.orders} pct={pct(orderType.third_party?.amount_raw)} />
    </div>
  );
};

export default OrderTypeCards;
